import React from "react";
import { ProjectBasicDataType, tagType } from "../../interface/interface";

import CouponCard from "./components/CouponCard";
import ProjectCard from "./components/ProjectCard";

import "./css/index.css";
function UserDetailList({
  tagarr,
  type,
  data,
}: {
  tagarr: Array<tagType>;
  type: string;
  data: ProjectBasicDataType[];
}) {
  return (
    <div className="userdetail-list">
      <div className={`tag-wrapper ${type}`}>
        {tagarr.map((item, idx) => {
          return (
            <div className={item.type} key={idx}>
              {item.title}
            </div>
          );
        })}
      </div>
      <div className="list-wrapper">
        {data.map((item, idx) => {
          return type === "project" ? (
            <ProjectCard key={idx} data={item} />
          ) : (
            <CouponCard key={idx} data={item} />
          );
        })}
      </div>
    </div>
  );
}

export default UserDetailList;
